/**
 * Product section (PDP): variant pills, quantity, share, and optional re-init on section load.
 */
function initProductVariantPicker(container) {
  const root = container || document;
  const form = root.querySelector('[data-product-form]');
  if (!form) return;
  const sectionRoot = form.closest('.product-section') || root;
  const currency = sectionRoot.getAttribute('data-currency') || 'BRL';
  const installmentsCount = parseInt(sectionRoot.getAttribute('data-installments-count'), 10) || 3;
  const jsonEl = sectionRoot.querySelector('[data-product-variants]') || root.querySelector('[data-product-variants]');
  const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

  const variantInput = form.querySelector('[data-variant-input]');
  const quantityInput = form.querySelector('[data-quantity-input]');
  const pills = form.querySelectorAll('[data-variant-pill]');
  const minusBtn = form.querySelector('[data-quantity-minus]');
  const plusBtn = form.querySelector('[data-quantity-plus]');
  const priceEl = sectionRoot.querySelector('[data-product-price]');
  const comparePriceEl = sectionRoot.querySelector('[data-product-compare-price]');
  const installmentsEl = sectionRoot.querySelector('[data-product-installments]');
  const addBtn = form.querySelector('.product-detail__add-button');

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency });
  }

  pills.forEach((pill) => {
    pill.addEventListener('click', function () {
      const id = this.getAttribute('data-variant-id');
      if (!id) return;
      if (variantInput) variantInput.value = id;
      pills.forEach((p) => p.classList.remove('product-detail__variant-pill--active'));
      this.classList.add('product-detail__variant-pill--active');
      const v = variants.find((x) => String(x.id) === id);
      if (v && priceEl) priceEl.textContent = formatMoney(v.price);
      if (v && comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparePriceEl.textContent = formatMoney(v.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (v && installmentsEl) {
        installmentsEl.textContent = 'ou ' + installmentsCount + 'x de ' + formatMoney(Math.round(v.price / installmentsCount));
      }
      if (addBtn) {
        addBtn.disabled = !v || !v.available;
        const textSpan = addBtn.querySelector('.product-detail__add-button-text');
        const iconSpan = addBtn.querySelector('.product-detail__add-icon');
        const addText = addBtn.getAttribute('data-add-text');
        const soldOutText = addBtn.getAttribute('data-sold-out-text');
        if (textSpan && addText != null && soldOutText != null) {
          textSpan.textContent = (v && v.available) ? addText : soldOutText;
        }
        if (iconSpan) iconSpan.style.display = (v && v.available) ? '' : 'none';
      }
    });
  });

  if (minusBtn && quantityInput) {
    minusBtn.addEventListener('click', () => {
      const n = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = Math.max(1, n - 1);
    });
  }
  if (plusBtn && quantityInput) {
    plusBtn.addEventListener('click', () => {
      const n = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = Math.min(99, n + 1);
    });
  }

  const shareBtn = sectionRoot.querySelector('[data-product-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', () => {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href });
      } else {
        navigator.clipboard.writeText(window.location.href);
      }
    });
  }
}

function initProductSections() {
  initProductVariantPicker(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSections);
} else {
  initProductSections();
}

document.addEventListener('shopify:section:load', (e) => {
  const sectionId = e.detail && e.detail.sectionId;
  if (!sectionId) return;
  const section = document.getElementById('shopify-section-' + sectionId);
  if (section) initProductVariantPicker(section);
});
